import React, { useCallback } from "react";
import { CommonModal } from "@components/modal";
import styled from "@emotion/styled";
import {
  CancelText,
  UnlinkQuestionText,
  UnlinkSuccessText,
  UnlinkText,
} from "@utils/lanugauge-settings/static-texts/TranslatedTexts";
import LoadingSpinner from "@screens/LoadingSpinner";

const ModalContents = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "4rem 0",
  fontSize: "1.8rem",
}));

const ButtonWrapper = styled.div(({ theme }) => ({
  display: "flex",
  gap: "0 2rem",
}));

const ModalButton = styled.button(({ theme, primary }) => ({
  padding: "1rem 2rem",
  background: primary ? theme.color.tertiary_grey : theme.color.primary_color,
  color: "white",
  borderRadius: "0.6rem",
}));

const KakaoUnlinkModal = ({
  openModal,
  setOpenModal,
  updateKakaoId,
  unlinkSuccess,
  setUnlinkSuccess,
  isLoading,
}) => {
  const unlinkKakaoUser = useCallback(() => {
    updateKakaoId({
      body: { kakaoId: null },
    });
  }, [updateKakaoId]);

  return (
    openModal && (
      <CommonModal
        noHeader
        openModal={openModal}
        setOpenModal={setOpenModal}
        closeEvent={() => setUnlinkSuccess(false)}
      >
        <ModalContents>
          {unlinkSuccess ? (
            <p>
              <UnlinkSuccessText />
            </p>
          ) : (
            <>
              <p>
                <UnlinkQuestionText />
              </p>

              {isLoading ? (
                <LoadingSpinner />
              ) : (
                <ButtonWrapper>
                  <ModalButton onClick={() => setOpenModal(false)}>
                    <CancelText />
                  </ModalButton>

                  <ModalButton primary onClick={unlinkKakaoUser}>
                    <UnlinkText />
                  </ModalButton>
                </ButtonWrapper>
              )}
            </>
          )}
        </ModalContents>
      </CommonModal>
    )
  );
};

export default KakaoUnlinkModal;
